import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApproveActionTypeModel } from '../../model/approveActionTypeModel';
import { environment } from '../../../environments/environment';
import { SubmitTransactionApprovalRequestModel } from '../../model/submitTransactionApprovalRequestModel';
import { SubmitTransactionApprovalResponseModel } from '../../model/submitTransactionApprovalResponseModel';

@Injectable()
export class BrokerTransactionApprovalService {

  private notifyPendingTransactionsList : EventEmitter<ApproveActionTypeModel[]> = new EventEmitter<ApproveActionTypeModel[]>() ;
  private notifySubmitTransactionApprovalResponseModel : EventEmitter<SubmitTransactionApprovalRequestModel> = new EventEmitter<SubmitTransactionApprovalRequestModel>() ;

  constructor(private http : HttpClient) { }

  //list of pending transactions for the broker to approve return ApproveActionTypeModel[]
getPendingTransactions(functionId : number){
  const params = new HttpParams()
  .set('FunctionID', functionId.toString());
    return this.http.get<ApproveActionTypeModel[]>(environment.server_url+"/api/BrokerTransactionApproval", {params});
}

//Submit transactions for approval/disapproval
submitBrokerTransaction(submitTransactionApprovalRequest : SubmitTransactionApprovalRequestModel){
  return this.http.post<SubmitTransactionApprovalResponseModel>(environment.server_url+"/api/BrokerTransactionApproval",submitTransactionApprovalRequest);
}


getNotifyPendingTransactionsList(){
  return this.notifyPendingTransactionsList;
}

getNotifySubmitTransactionApprovalResponseModel(){
  return this.notifySubmitTransactionApprovalResponseModel;
}
}



// WEBPACK FOOTER //
// ./src/app/broker/view-pending-approvals/broker-transaction-approval.service.ts